import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PreviousRouteService } from './previous-route.service';
import * as clevertap from 'clevertap-web-sdk';
import { RootService } from "../root.service";
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ClevertapService {

  userData: any;
  UserId: any = "";
  gender: any = "M";
  UserMobileNo: any = "";
  UserEmail: any = "";
  CustomerName: any = "";
  UserPincode: any = "";
  UserAddress: string = "";

  constructor(private storageService: RootService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object, private previousRoute: PreviousRouteService) {
      
  }

  webpush() {
    if (isPlatformBrowser(this.platformId)) {
      clevertap.notifications.push({
        "titleText": "Would you like to receive Push Notifications?",
        "bodyText": "We promise to only send you relevant content and give you updates on your transactions",
        "okButtonText": "Sign me up!",
        "rejectButtonText": "No thanks",
        "okButtonColor": "#F28046",
        "askAgainTimeInSeconds": 5,
        "serviceWorkerPath": "./service-worker.js", // path to your custom service worker file
        "skipDialog":true
      });
    }
  }

  async onLanguageChange(language: any) {
    if (isPlatformBrowser(this.platformId)) {
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
      await this.getloginUserDetails();
      let login = (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes";
        clevertap.event.push("Language Change", {
          "Language": language,
          "ProductURL": baseurl,
          "Logged In": login,
          "Wa_ProductURL":(this.router.url).substring(1)
        });
    }
  }
  async getloginUserDetails() {
    // async getloginUserDetails(eventName:any, pagename?:any) {
    if (isPlatformBrowser(this.platformId)) {
      this.userData = null
      this.UserMobileNo = "";
      this.UserId = "";
      this.UserEmail = "";
      this.CustomerName = "";
      this.UserAddress = "";
      this.UserPincode = "";
      let res :any =  this.storageService.isLoggedIn();
        if (res) {
          this.userData = this.storageService.getUserData() ? this.storageService.getUserData():null;
          if (this.userData) {
            this.UserMobileNo = this.userData?.mobile_number ? this.userData?.mobile_number : "";
            this.UserEmail = this.userData?.email_id ? this.userData?.email_id : "";
            this.UserId = this.userData?.id ? this.userData?.id : "",
            this.CustomerName = this.userData?.first_name + " " + this.userData?.last_name;
            this.UserAddress = this.userData?.address_one + ", " + this.userData?.state + ", " + this.userData?.district + ", " + this.userData?.city + ", " + this.userData?.taluka;
            this.UserPincode = this.userData?.pincode;
          }
          return this.userData;

        } else {
          this.userData = null
          return this.userData;
        }

    }
  }
//not in use still but DO NOT REMOVE
  async onUserLogin(name:any,email:any,mobile:any) {

    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();

        await clevertap.event.push(
          "Login", {
            "User ID": String(mobile),
            "Name": String(name),
            "Phone": String(mobile),
            "Identity": String(mobile),
            "Email": String(email),
          }
        );
      }
    }

    async onUserSignup(name:any,email:any,mobile:any) {

      if (isPlatformBrowser(this.platformId)) {
        await this.getloginUserDetails();
        var d = new Date();

        var date = d.getDate();
        var month = d.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
        var year = d.getFullYear();

        var dateStr:Date  = new Date(date + "-" + month + "-" + year);


          await clevertap.event.push(
            "Sign Up", {
              "User ID": String(mobile),
              "Name": String(name),
              "Phone": String(mobile),
              "Identity": String(mobile),
              "Email": String(email),
              "Sign Up Date":dateStr
            }
          );
        }
      }
//   async PostonUserLogin(): Promise<void> {
//     if (isPlatformBrowser(this.platformId)) {
//       await this.getloginUserDetails();
//       if (this.userData == null || this.userData == "" || this.userData == undefined) {

//       }
//       else {
//         await clevertap.event.push("Login", {
//           "User ID": this.UserId,
//           "Name": this.CustomerName,
//           "Phone": '+91' + this.UserMobileNo,
//           "Identity": this.UserId,
//           "Email": this.UserEmail,
//         });
//       }
//     }
//   }
  async onPageView(pagename: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
      clevertap.event.push("Page View", {
        "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
        "Page URL": baseurl,
        "Last Page": typeof window !== 'undefined' ? window.location.origin + this.previousRoute.getPreviousUrl():' ',
        "Page Name": pagename,
        "Wa_Page URL" : (this.router.url).substring(1),
        "Wa_Last Page" : (this.previousRoute.getPreviousUrl()).substring(1)
      });
    }

  }
  async onFindBySearch(Type: any, KeyValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
        clevertap.event.push("Find By Search", {
          "Logged In":(this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Key Value": KeyValue,
          "Type": Type,
        });
    }
  }

  async OnSectionClick(Category: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
        clevertap.event.push("Section Click", {
          "Category": Category,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          // "Transport Type": TransportType,//bussiness requirement
        });
    }
  }

  async onUserSignUpFunc(name:any,last_name,email:any,mobile:any): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      if (this.userData == null || this.userData == "" || this.userData == undefined) {
      }
      else {
        await clevertap.onUserLogin.push({
          "Site": {
            "Name":name+' '+last_name,
            "First Name": name,
            "Last Name": last_name,
            "Identity": this.UserId,
            "Email": email,
            "Phone": '+91' + mobile,
            "Gender": this.gender,                     // Can be either M or F
            "DOB": "",
            "MSG-email": false,
            "MSG-push": true,
            "MSG-sms": true,
            "MSG-whatsapp": true,           // Enable WhatsApp notifications
          }
        })

      }
    }
  }
  async PostonUserSignUp(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      if (this.userData == null || this.userData == "" || this.userData == undefined) {

      }
      else {
        await clevertap.event.push("Sign Up", {
          "User ID": this.UserId,
          "Name": this.CustomerName,
          "Phone": '+91' + this.UserMobileNo,
          "Identity": this.UserId,
          "Email": this.UserEmail,
          "Sign Up Date": new Date(),
        });
      }
    }
  }
  // async onProductViewed(Category: any, SubCategory: any, ProductLine: any, ProductID: any, ProductName: any, ProductImage: any, Section: any,ShowroomPrice:any, BookingAmount:any, KVF1:any,KVF2:any,KVF3:any,KVF4:any) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     await this.getloginUserDetails();
  //     var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
  //       clevertap.event.push("Product Viewed", {
  //         "Category": Category,
  //         "Sub Category": SubCategory,
  //         "Product Line": ProductLine,
  //         "Product ID": ProductID,
  //         "Product Name": ProductName,
  //         "Product Image": ProductImage,
  //         "ProductURL": baseurl,
  //         "Section": Section,
  //         "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
  //         "Ex-Showroom Price" :ShowroomPrice,
  //         "Booking Amount":BookingAmount,
  //         "KVF 1":KVF1,
  //         "KVF 2":KVF2,
  //         "KVF 3":KVF3,
  //         "KVF 4":KVF4,
            // "Wa_ProductURL":
  //       });
  //   }
  // }

  async onProductViewDetails(ProductID: any, ProductName: any, ProductImage: any, Section: any,SubCategory: any,
    Category:any , ProductLine:any, ShowroomPrice:any, BookingAmount:any, KVF1:any,KVF2:any,KVF3:any,KVF4:any,CheckoutURL:any,
    wspURL:any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
        clevertap.event.push("Product View Details", {
          "Product Image": ProductImage,
          "Product ID": ProductID,
          "Product Name": ProductName,
          "ProductURL": baseurl,
          "Section": Section,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Checkout URL":CheckoutURL,
          "Sub Category":SubCategory,
          "Category":Category,
          "Product Line":ProductLine,
          "Ex-Showroom Price" :ShowroomPrice,
          "Booking Amount":BookingAmount,
          "KVF 1":KVF1,
          "KVF 2":KVF2,
          "KVF 3":KVF3,
          "KVF 4":KVF4,
        "Wa_ProductURL" : (this.router.url).substring(1),
        "Wa_Checkout URL" : (wspURL).substring(1)
        });
    }
  }
  async proceedToPayment(FirstName: any, LastName: any, mobile_number: any, email_id: any, state: any, city: any, district: any, taluka: any,
    pincode: any, dealer: any, Application: any, Finance: any, Quantity: any,ProductID: any, ProductImage: any, ProductName: any, ProductURL: any, ExShowroomPrice: any,
    BookingAmount: any, DseId:any, FinananceApproval:any, FinanaceDrp:any, amc:any ,KVF1: any, KVF2: any, KVF3: any, KVF4: any,SubCategory: any,
    Category:any , ProductLine:any,wspURL:any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
        clevertap.event.push("Proceed to Payment Click", {
          "First Name": FirstName,
          "Last Name": LastName,
          "Phone No": mobile_number,
          "Email Id": email_id,
          "State": state,
          "City": city,
          "District": district,
          "Taluka": taluka,
          "Pincode": pincode,
          "Dealer": dealer,
          "Application": Application,
          // "Finance": Finance,
          "Quantity": Quantity,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Product ID":ProductID,
          "Product Image":ProductImage,
          "Product Name":ProductName,
          "ProductURL":ProductURL,
          "Sub Category":SubCategory,
          "Category":Category,
          "Product Line":ProductLine,
          "Ex-Showroom Price":ExShowroomPrice,
          "Booking Amount":BookingAmount,
          "Checkout URL":ProductURL,
          "DSE CRM ID":DseId,
          "Have Financial Approval":FinananceApproval,
          "Finance Dropdown Value":FinanaceDrp,
          "Annual Maintenance Contract":amc,
          "KVF 1":KVF1,
          "KVF 2":KVF2,
          "KVF 3":KVF3,
          "KVF 4":KVF4,
          "Wa_ProductURL":(wspURL).substring(1),
          "Wa_Checkout URL":(wspURL).substring(1)
        });
    }
  }

  async onBookNowButtonClick(ProductID: any, ProductName: any, ProductImage: any, Section: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
        clevertap.event.push("Book Now Button Click", {
          "Product ID": ProductID,
          "Product Name": ProductName,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "ProductURL": baseurl,
          "Product Image": ProductImage,
          "Section": Section,
          "Wa_ProductURL":(this.router.url).substring(1)
        });
    }
  }

  async enquiryButtonClick(FirstName: any, LastName: any, ProductName: any, PhoneNo: any, Pincode: any, action_type: any) {
    if (isPlatformBrowser(this.platformId)) {
      let EventName = action_type == 'Enquiry Popup' ? 'Enquiry Form Pop Up Submit' : 'Enquiry Form Submit'
      await this.getloginUserDetails();
        clevertap.event.push(EventName, {
          "First Name": FirstName,
          "Last Name": LastName,
          "Product Name": ProductName,
          "Phone No": PhoneNo,
          "Pincode": Pincode,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
        });
    }
  }

  async onProductDetailsPageButtonClick(ButtonName: any, ProductID: any, ProductName: any, ProductImage: any, Section: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
        clevertap.event.push("Product Details Page Button Click", {
          "Product ID": ProductID,
          "Button Name": ButtonName,
          "Product Image": ProductImage,
          "Product Name": ProductName,
          "ProductURL": baseurl,
          "Section": Section,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Wa_ProductURL":(this.router.url).substring(1)
        });
    }
  }

  async onTransactionFlowSignUpSuccess() {
        await this.getloginUserDetails();

    // async onTransactionFlowSignUpSuccess(CustomerName: any, StateDropdownValue: any, DistrictDropdownValue: any, TalukaDropdownValue: any, PinCodeValue: any, DealershipDropdownValue: any, ApplicationDropdownValue: any, FinanceDropdownValue: any, CompanyValue: any, ProductID: any, ProductName: any, ProductImage: any, Section: any, billbaseUrl: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
        clevertap.event.push("Transaction Flow Sign Up Success", {
          "Customer Name": this.userData.first_name + " " + this.userData.last_name,
          "District Dropdown Value": this.userData.district,
          "State Dropdown Value": this.userData.state,
          "Pin Code Value":"",
          "Taluka Dropdown Value":"",
          "Finance Dropdown Value": "",
          "Dealership Dropdown Value": "",
          "Application Dropdown Value":"",
          "Product Name": "",
          "Company Value":"",
          "Section":"",
          "Product ID": "",
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "ProductURL": "",
          "Product Image": "",
          "Wa_ProductURL":""
        });
    }
  }


  async onPaymentOptionSelected(PaymentMode: any, ProductID: any, ProductName: any, ProductImage: any, Section: any) {
    if (isPlatformBrowser(this.platformId)) {
      await this.getloginUserDetails();
        clevertap.event.push("Payment Option Selected", {
          "Product ID": ProductID,
          "Payment Mode": PaymentMode,
          "Product Name": ProductName,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Product Image": ProductImage,
          "Section": Section,
          "ProductURL": typeof window !== 'undefined' ? window.location.href :' ',
          "Wa_ProductURL":(this.router.url).substring(1)
        });
    }
  }

  async onPaymentCompleted(Status: any, PaymentMode: any, ProductID: any, ProductName: any, ProductImage: any,
    Section: any,SubCategory: any,
    Category:any , ProductLine:any, ShowroomPrice:any, BookingAmount:any, AmountPaid:any) {
      if (isPlatformBrowser(this.platformId)) {
      var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
      await this.getloginUserDetails();
        clevertap.event.push("Payment Completed", {
          "Status": Status,
          "Product ID": ProductID,
          "Payment Mode": PaymentMode,
          "Product Image": ProductImage,
          "Product Name": ProductName,
          "Section": Section,
          "ProductURL": baseurl,
          "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
          "Sub Category": SubCategory,
          "Category":Category,
          "Product Line":ProductLine,
          "Ex-Showroom Price":ShowroomPrice,
          "Booking Amount":BookingAmount,
          "Amount Paid":AmountPaid,
          "Wa_ProductURL":(this.router.url).substring(1)
        });
    }
  }

  async onTestRideInitiated( ProductID: any, ProductName: any, ProductImage: any,Category: any, SubCategory: any, ProductLine: any, ShowroomPrice:any,
    BookingAmount:any,KVF1:any,KVF2:any,KVF3:any,KVF4:any,url:any) {

        if (isPlatformBrowser(this.platformId)) {
           var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
            clevertap.event.push("Test Ride Initiated", {
              "Product ID": ProductID,
              "Product Name": ProductName,
              "ProductURL": baseurl,
              "Product Image": ProductImage,
              "Category": Category,
              "Sub Category": SubCategory,
              "Product Line": ProductLine,
              "Logged In": "Yes",
              "Ex-Showroom Price" :ShowroomPrice,
              "Booking Amount":BookingAmount,
              "Checkout URL":typeof window !== 'undefined' ? window.location.origin+url:'',
              "KVF 1":KVF1,
              "KVF 2":KVF2,
              "KVF 3":KVF3,
              "KVF 4":KVF4,
              "Test_Ride_ID":"",
              "Wa_ProductURL":(this.router.url).substring(1),
              "Wa_Checkout URL":(this.router.url).substring(1)
            });
        }
      }

      async onTestRideBooked( ProductID: any, ProductName: any, ProductImage: any,Category: any, SubCategory: any, ProductLine: any, FirstName:any,
        LastName:any,State:any,District:any,Dealer:any,DOFBTD:any,checkoutUrl:any,BTDMode:Date) {

            if (isPlatformBrowser(this.platformId)) {
              var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
                clevertap.event.push("Test Ride Booked", {
                  "Product ID": ProductID,
                  "Test ride mode":BTDMode,
                  "Product Name": ProductName,
                  "ProductURL": baseurl,
                  "Product Image": ProductImage,
                  "Category": Category,
                  "Sub Category": SubCategory,
                  "Product Line": ProductLine,
                  "Checkout URL":typeof window !== 'undefined' ? window.location.origin+checkoutUrl:'',
                  "Logged In": "Yes",
                  "First Name":FirstName,
                  "Last Name":LastName,
                  "Email Address":"",
                  "State":State,
                  "District":District,
                  "Dealer":Dealer,
                  "Date Of Book Test Drive":DOFBTD,
                  "Wa_ProductURL":(this.router.url).substring(1),
                  "Wa_Checkout URL":(this.router.url).substring(1)
                });
            }
          }

   async onProductAddedtocart( ProductID: any, ProductImage: any, ProductName: any,Category: any, SubCategory: any, ProductLine: any, ShowroomPrice:any,
    BookingAmount:any,KVF1:any,KVF2:any,KVF3:any,KVF4:any) {
        if (isPlatformBrowser(this.platformId)) {
          await this.getloginUserDetails();
          var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
            clevertap.event.push("Product Added to cart", {
              "Product ID": ProductID,
              "Product Name": ProductName,
              "ProductURL": baseurl,
              "Product Image": ProductImage,
              "Category": Category,
              "Sub Category": SubCategory,
              "Product Line": ProductLine,
              "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
              "Ex-Showroom Price" :ShowroomPrice,
              "Booking Amount":BookingAmount,
              "Checkout URL":baseurl,
              "KVF 1":KVF1,
              "KVF 2":KVF2,
              "KVF 3":KVF3,
              "KVF 4":KVF4,
              "Wa_ProductURL":(this.router.url).substring(1),
              "Wa_Checkout URL":(this.router.url).substring(1)
            });
        }
      }
      async onFinanceInitiated( FirstName: any, LastName: any, PhoneNo: any,EmailId: any, State: any, City: any, District:any,
        Taluka:any, Pincode: any, Dealer: any, Application: any,Quantity: any, ProductID: any, ProductName: any, ProductImage:any,
        Category:any,SubCategory: any, ProductLine: any, ExShowroomPrice: any,BookingAmount: any, KVF1:any,KVF2:any,KVF3:any,KVF4:any,Dse:any) {
            if (isPlatformBrowser(this.platformId)) {

                var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
                clevertap.event.push("Proceed For Finance Initiated", {
                  "First Name": FirstName,
                  "Last Name": LastName,
                  "Phone No": PhoneNo,
                  "Email Id": EmailId,
                  "State": State,
                  "City": City,
                  "District": District,
                  "Taluka":Taluka,
                  "Pincode" :Pincode,
                  "Dealer":Dealer,
                  "Application":Application,
                  "Quantity":Quantity,
                  "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
                  "Product ID": ProductID,
                  "Product Image ": ProductImage,

                  "Product Name": ProductName,
                  "ProductURL": baseurl,
                  "Sub Category": SubCategory,
                  "Category": Category,

                  "Product Line": ProductLine,
                  "Ex-Showroom Price":ExShowroomPrice,
                  "Booking Amount":BookingAmount,
                  "KVF 1":KVF1,
                  "KVF 2":KVF2,
                  "KVF 3":KVF3,
                  "KVF 4":KVF4,
                  "DSE CRM ID":Dse
                });
            }
          }
          async onPaymentfailed(ProductID: any,PaymentMode: any, ProductImage: any,ProductName: any, Section: any,
             SubCategory: any,
            Category:any , ProductLine:any, ShowroomPrice:any, BookingAmount:any, AmountPaid:any) {

            if (isPlatformBrowser(this.platformId)) {

              var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
              await this.getloginUserDetails();
                clevertap.event.push("Payment Failed", {
                  "Status": "failure",
                  "Product ID": ProductID,
                  "Payment Mode": PaymentMode,
                  "Product Image": ProductImage,
                  "Product Name": ProductName,
                  "Section": Section,
                  "ProductURL": baseurl,
                  "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
                  "Sub Category": SubCategory,
                  "Category":Category,
                  "Product Line":ProductLine,
                  "Ex-Showroom Price":ShowroomPrice,
                  "Booking Amount":BookingAmount,
                  "Amount Paid":AmountPaid,
                  "Wa_ProductURL":(this.router.url).substring(1)
                });
            }
          }

          async onIdleScreen() {

            if (isPlatformBrowser(this.platformId)) {
              await this.getloginUserDetails();
                clevertap.event.push("Idle Mode", {
                  "Type": "",
                  "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
                });
            }
          }

          async onUserLogFunc(name:any,last_name:any,email:any,mobile:any): Promise<void> {
            if (isPlatformBrowser(this.platformId)) {
              await this.getloginUserDetails();
              if (this.userData == null || this.userData == "" || this.userData == undefined) {

              }
              else {
                await clevertap.onUserLogin.push({
                  "Site": {
                    "Name":name+' '+last_name,
                    "First Name": name,
                    "Last Name": last_name,
                    "Identity": this.UserId,
                    "Email": email,
                    "Phone": '+91' + mobile,
                    "Gender": this.gender,
                    "DOB": "",
                    "MSG-email": false,
                    "MSG-push": true,
                    "MSG-sms": true,
                    "MSG-whatsapp": true,
                  }
                })
              }
            }
          }
          async LandingPageViewed(ProductID: any, ProductName: any, ProductImage: any,
            SubCategory: any,
            Category:any , ProductLine:any,landingPageURL:any, ShowroomPrice:any, BookingAmount:any) {
              if (isPlatformBrowser(this.platformId)) {
              var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
              await this.getloginUserDetails();
                clevertap.event.push("Landing Page Viewed", {

                  "Product Image": ProductImage,
                  "Product ID": ProductID,
                  "Product Name": ProductName,
                  "ProductURL": baseurl,
                  "Sub Category": SubCategory,
                  "Category":Category,
                  "Product Line":ProductLine,
                  "Landing Page URL": landingPageURL,
                  "Ex-Showroom Price":ShowroomPrice,
                  "Booking Amount":BookingAmount,
                  // "Section": Section,
                  // "Logged In": (this.userData == null || this.userData == "" || this.userData == undefined) ? "No" : "Yes",
                  // "Amount Paid":AmountPaid

                });
            }
          }
          async  GetCodeClicked
          (eventName:any,mobileNumber:any,ProductID: any, ProductName: any,landingPageURL:any) {
              if (isPlatformBrowser(this.platformId)) {
              var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
              await this.getloginUserDetails();
                clevertap.event.push(eventName, {

                  "Mobile number": mobileNumber,
                  "Product ID": ProductID,
                  "Product Name": ProductName,
                  "ProductURL": baseurl,
                  "Landing Page URL": landingPageURL,

                });
            }
          }
          async CodeVerified( FirstName:any,LastName:any,State: any, District: any,
             Dealer: any,Quantity: any,
             MobileNumber: any, ProductID: any, ProductName:any,checkoutUrl:any) {

                if (isPlatformBrowser(this.platformId)) {
                  var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
                    clevertap.event.push('Code Verified', {
                      "First Name":FirstName,
                      "Last Name":LastName,
                      "State":State,
                      "District":District,
                      "Dealer":Dealer,
                      "Quantity":Quantity,
                      "Mobile number": MobileNumber,
                      "Product ID": ProductID,
                      "Product Name": ProductName,
                      "ProductURL": baseurl,
                      "Landing Page URL":typeof window !== 'undefined' ? window.location.origin+checkoutUrl:'',

                    });
                }
              }

          async FormSubmitted( event:any,State: any, District: any, Dealer: any,Quantity: any,
            ProductImage: any, ProductID: any, ProductName:any,checkoutUrl:any,SubCategory:any,
            Category:any,ProductLine:any,ShowroomPrice:any,BookingAmount:any) {

                if (isPlatformBrowser(this.platformId)) {
                  var baseurl = typeof window !== 'undefined' ? window.location.href :' ';
                    clevertap.event.push(event, {
                      "State":State,
                      "District":District,
                      "Dealer":Dealer,
                      "Quantity":Quantity,
                      "Product Image": ProductImage,
                      "Product ID": ProductID,
                      "Product Name": ProductName,
                      "ProductURL": baseurl,
                      "Landing Page URL":typeof window !== 'undefined' ? window.location.origin+checkoutUrl:'',
                      "Sub Category": SubCategory,
                      "Category": Category,
                      "Product Line": ProductLine,
                      "Ex-Showroom Price":ShowroomPrice,
                      "Booking Amount":BookingAmount,

                    });
                }
              }

              async pushCustomEvent(eventName: string, eventObject: object) {
                if (isPlatformBrowser(this.platformId)) {
                    clevertap.event.push(eventName,eventObject);
                }
              }

}


